import React from "react";
import { ComponentProductCategoriesType } from "@swo/storefront";
import { ContentfulImage2 } from "../_shared-components/image-related/ContentfulImage2";
import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../styles/fonts";
import { CSS_MQ } from "../../styles/breakpoints";
import { useNavigate } from "react-router";

export function ProductCategoriesComponent(props: ComponentProductCategoriesType) {
  const navigate = useNavigate();

  return (
    <ContentContainer>
      <div
        css={css`
          display: grid;
          justify-content: center;

          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 6px;

          ${CSS_MQ.atLeastLg} {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 20px;
          }
        `}
      >
        {props.items.map(i => {
          const internalLink = i.callToAction.internalLink;
          return (
            <div
              key={i.headline}
              className="u-relative"
              css={css`
                width: calc(100% / 2 - var(--gx));
                ${CSS_MQ.atLeastMd} {
                  width: calc(100% / 3 - var(--gx));
                }
                ${CSS_MQ.atLeastXl} {
                  width: calc(25% - var(--gx));
                }

                display: flex;
                flex-direction: column;
                align-items: center;
              `}
            >
              <ContentfulImage2
                assetId={i.image.sys.id}
                contentfulUrl={i.image.url}
                withTransparency={true}
                cropping={undefined}
                sizes="(max-width: 767px) 50vw, (max-width: 1399px) 466px, 350px"
                onClick={() => {
                  void navigate(internalLink, {
                    preventScrollReset: false,
                  });
                }}
                className="u-cursor-pointer"
                css={css`
                  width: 100%;
                  height: 100%;
                  object-fit: contain;

                  aspect-ratio: 4 / 3;
                `}
              />

              <span
                className="u-uppercase u-ta-center u-block u-grow u-color-green"
                css={[
                  FONTS.MinervaModern500,
                  fontSize.x4,
                  css`
                    margin-bottom: 12px;
                    ${CSS_MQ.atLeastLg} {
                      margin-bottom: 16px;
                    }
                  `,
                ]}
              >
                {i.headline}
              </span>

              <SwarovskiButton variant={"outline"} as={"a"} link={internalLink} isInternal={true} size={"small"}>
                {i.callToAction.label}
              </SwarovskiButton>
            </div>
          );
        })}
      </div>
    </ContentContainer>
  );
}
